__turbopack_context__.v({
  "loaderContainer": "loadingSpinner-module-scss-module__YuHD_G__loaderContainer",
  "spin-anim": "loadingSpinner-module-scss-module__YuHD_G__spin-anim",
  "spinner": "loadingSpinner-module-scss-module__YuHD_G__spinner",
});
